import $ from 'jquery';

// Bootstrap requirement
import 'popper.js';

// Bootstrap JS Modules add here
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

// Theme Modules
import Carousel from './modules/carousel';
import Calendar from './modules/calendarLoader';
import Cart from './modules/cartLoader';
import Nav from './modules/navLoader';
import MapLoader from './modules/mapLoader';
import Masonry from './modules/masonryLoader';
import ImageLoader from './modules/imageLoader';
import VacancyLoader from './modules/vacancyLoader';
import Equalizer from './modules/equalHeights.js';
import PhotoCompetition from './modules/photoCompetitionLoader';
import Fullpage from './modules/fullpageScroller';
import LightGallery from './modules/lightGallery';
import RevealOnScroll from './modules/revealOnScroll';

// Plugins
import 'lightgallery';
import 'lg-video';
import 'pace-js-amd-fix';

(function() {
    paceOptions = {
        ajax: true,
        startOnPageLoad: false,
        restartOnRequestAfter: 100
    };

    Nav.init();
	ImageLoader.init();
	Carousel.init();
	Masonry.init();
    VacancyLoader.init();
    Calendar.init();
    PhotoCompetition.init();
    MapLoader.init();

    if ($('#home').length) {
        Fullpage.new('#fullpage');
    }

    Equalizer.new({
        each: '.cta-children a'
    });

    Equalizer.new({
        each: '#shop-landing #filters .cta'
    });

    Equalizer.new({
        each: '#simple-children a'
    });

    Equalizer.new({
        each: '#mariner .links .cta'
    });
    
    Equalizer.new({
        each: '#documents h3'
    });

    Equalizer.new({
        each: '.dashboard .documents ul li a h3'
    });

    if ($('.cart').length) {
        Cart.init({
            element: '.cart'
        });        
    }

    $('#video').lightGallery({
        youtubePlayerParams: {
            rel: 0,
            wmode: 'transparent',
            autoplay: 1,
            modestbranding: 1,
            showinfo: 0,
            controls: 0
        }
    });

    $('#asset-gallery').lightGallery({
        thumbnail: true,
        selector: 'a:not(".vote")',
        download: false
    });

    LightGallery.new({
        youtube: true,
        selector: '.btn-play',
        parent: '.video-link'
    });

    $('#shop-landing').on('click', '#filters a', function(e) {
        e.preventDefault();

        var $this = $(this);

        $filters.find('a').removeClass('active');
        $this.addClass('active');

        $('#products-list-container').load($this.attr('href') + ' #products-list', function() {
            Equalizer.new({
                each: '#products-list h3'
            });

            Equalizer.new({
                each: '#products-list h4'
            });

            Equalizer.new({
                each: '#products-list >li > div'
            });
        });
    });

    const $filters = $('#filters');

    $filters.on('change', 'select', function() {
        $.get(window.location, $filters.find('form').serialize())
            .done(function(response) {
                $('.filtered').replaceWith($(response).find('.filtered'));
            });
    });

    $('#subscribe-select-all').on('change', function() {
        var $mailingList = $('.mailing-list-checkbox');

        if ($(this).is(':checked')) {
            $mailingList.prop('checked', true);

        } else {
            $mailingList.prop('checked', false);
        }
    });

    $('.print').on('click', function(e) {
        e.preventDefault();

        window.print();
    });

    $('[data-href]').on('click', function(e) {
        e.preventDefault();

        window.location = $(this).data('href');
    });

    $('#myTab a').on('click', function (e) {
        e.preventDefault()
        $(this).tab('show')
    });

    $('.cs-accordion-btn').on('click', function() {
        // if (!$this.hasClass('collapsed')) {
            $(this).toggleClass('active');             
        // }
    });

    RevealOnScroll.load('.siblings-next-wrap', '95%');
})();


// WEBPACK FOOTER //
// ./src/js/app.js